<template>
  <div
    v-show="isVisible"
    data-notify="container"
    class="alert open alert-with-icon"
    role="alert"
    :class="[verticalAlign, horizontalAlign, alertType]"
    :style="customPosition"
    data-notify-position="top-center"
    @click="close"
  >
    <button
      type="button"
      aria-hidden="true"
      class="close"
      data-notify="dismiss"
      @click="close"
    >
      ×
    </button>
    <i
      data-notify="icon"
      class="material-icons"
    >{{ icon }}</i>
    <span
      v-safe-html="message"
      data-notify="message"
    />
    <div
      v-if="timeout"
      ref="progressBar"
      class="progress-bar"
      :style="progressBarStyle"
    />
  </div>
</template>
<script>
export default {
  name: "Notification",
  props: {
    message: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: "add_alert"
    },
    verticalAlign: {
      type: String,
      default: "top",
    },
    horizontalAlign: {
      type: String,
      default: "center",
    },
    type: {
      type: String,
      default: "info",
    },
    timeout: {
      type: Number,
      default: () => 0,
    },
    timestamp: {
      type: Date,
      default: () => new Date(),
    },
    onClose: {
      type: Function,
      default: () => undefined,
    }
  },
  data() {
    return {
      elmHeight: 0,
      isVisible: true,
      timeoutRef: null,
    };
  },
  computed: {
    hasIcon() {
      return this.icon && this.icon.length > 0;
    },
    alertType() {
      return `alert-${this.type}`;
    },
    customPosition() {
      let initialMargin = 20;
      let alertHeight = this.elmHeight + 10;
      let sameAlertsCount = this.$notifications.state.filter(alert => {
        return (
          alert.horizontalAlign === this.horizontalAlign &&
          alert.verticalAlign === this.verticalAlign &&
          alert.timestamp <= this.timestamp
        );
      }).length;
      let pixels = sameAlertsCount * alertHeight + initialMargin;
      let styles = {};
      if (this.verticalAlign === "top") {
        styles.top = `${pixels}px`;
      } else {
        styles.bottom = `${pixels}px`;
      }
      return styles;
    },
    progressBarStyle() {
      return {
        animationDuration: `${this.timeout}ms`
      };
    }
  },
  async mounted() {
    this.elmHeight = this.$el.clientHeight;
    if (this.timeout) {
      await this.$nextTick();
      this.$refs.progressBar.addEventListener("animationend", this.close);
      this.timeoutRef = setTimeout(this.close, this.timeout);
    }
  },
  async beforeDestroy() {
    if (this.timeout) {
      await this.resetTimeout();
    }
  },
  methods: {
    async close() {
      this.isVisible = false;
      if (this.timeout) {
        await this.resetTimeout();
      }
      if (this.onClose) {
        this.onClose();
      }
      this.$emit("on-close");
    },
    async resetTimeout() {
      await this.$nextTick();
      this.$refs.progressBar.removeEventListener("animationend", this.close);
      clearTimeout(this.timeoutRef);
    }
  },
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 991px) {
  .alert {
    width: auto !important;
    margin: 0 10px;

    &.left {
      left: 0 !important;
    }
    &.right {
      right: 0 !important;
    }
    &.center {
      margin: 0 10px !important;
    }
  }
}

.alert {
  z-index: 100;
  cursor: pointer;
  position: fixed;
  width: 41%;

  &.center {
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    margin: 0 auto;
  }
  &.left {
    left: 20px;
  }
  &.right {
    right: 20px;
  }

  .progress-bar {
    @keyframes scale-x-frames {
      0% {
        transform: scaleX(1);
      }
      100% {
        transform: scaleX(0);
      }
    }

    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 5px;
    background-color: rgba(255, 255, 255, 0.7);
    transform-origin: left;
    animation: scale-x-frames linear 1 forwards;
  }
}
</style>
